import React from "react";
import { Link } from "react-router-dom";
import { useState } from "react"


export default function Service2() {
    const [activeIndex, setActiveIndex] = useState(1)
    const handleOnClick = (index) => {
        setActiveIndex(index)
    }
    return (
        <>


            <section className="service-6-section">
                <div className="auto-container">
                <div className="section_heading text-center mb_60">
                    <span className="section_heading_title_small">Services</span>
                    <h2 className="section_heading_title_big">Everyone Deserves Our <br /> Best Services</h2>
                </div>
                    <div className="tabs-box">
                        <div className="tab-btn-box p_relative mb_100">
                            <ul className="nav nav-tabs service-6-tab-btn" role="tablist">
                                <li className="nav-link" onClick={() => handleOnClick(1)}>
                                    <a className={activeIndex == 1 ? "nav-link active" : "nav-link"}><div className="service-6-tab-title">Personal  Care</div></a>
                                </li>
                                <li className="nav-item" onClick={() => handleOnClick(2)}>
                                    <a className={activeIndex == 2 ? "nav-link active" : "nav-link"}><div className="service-6-tab-title">Everyday Life</div></a>
                                </li>
                                <li className="nav-item" onClick={() => handleOnClick(3)}>
                                    <a className={activeIndex == 3 ? "nav-link active" : "nav-link"}><div className="service-6-tab-title">Fun, innovative community</div></a>
                                </li>
                               
                            </ul>
                        </div>
                        <div className="tab-content wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1200ms">
                            <div className={activeIndex == 1 ? "tab-pane fadeInUp animated show active" : "tab-pane fadeInUp animated"}>
                            <div className="row clearfix">
                                <div className="col-lg-6">
                                    <h3 className="mb_30 fs_40">Our assistance is for everyday life itself:</h3>
                                    <p className="mb_30 me-lg-5">Our job is to ensure that completing crucial everyday activities such as hygiene, dressing, communications and lifestyle support is never a burden for you. Enjoy the best general personal care and support, where the “easiest” tasks in daily life are properly assisted, supervised, and made a lot more convenient for you.    </p>
                                    <div className="row mb_30">
                                        <div className="col-md-6">
    <ul className="service-6-list">
        <li>Personal hygiene assistance</li>
        <li>Support with dressing and grooming</li>
        <li>Communication assistance and support</li>
        <li>Lifestyle and routine support</li>
    </ul>
</div>
<div className="col-md-6">
    <ul className="service-6-list">
        <li>General personal care and supervision</li>
        <li>Convenient help with simple daily tasks</li>
        <li>Encouragement toward independence</li>
        <li>Reliable everyday activity assistance</li>
    </ul>
</div>
                                    </div>       
                                    {/* <div className="link-btn mb_30">
                                        <Link href="#" className="btn-1">Read More <span></span></Link>
                                    </div>              */}
                                </div>
                                <div className="col-lg-6">
                                    <div className="p_relative text-lg-end">
                                        <div className="service-6-shape"><img src="assets/images/shape/pattern-1.png" alt="" /></div>
                                        <div className="p_relative">
                                            <img src="assets/images/resource/holdinghands.jpg" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div className={activeIndex == 2 ? "tab-pane fadeInUp animated show active" : "tab-pane fadeInUp animated"}>
                                <div className="row clearfix">
                                    <div className="col-lg-6">
                                        <h3 className="mb_30 fs_40">Daily care</h3>
                                        <p className="mb_30 me-lg-5">the support services funded by NDIS plan budgets, based on the type of assistance you choose to receive from your support worker. Your support worker will be your dependable friend, helping you work up on learning about public transport, resumes, taxes, saving, social and physical skills. Expect to enter your desired life of independence, where your daily activities are supervised in the most convenient way.  </p>
                                        <div className="row mb_30">
                                          <div className="col-md-6">
    <ul className="service-6-list">
        <li>Learning to use public transport</li>
        <li>Resume and job preparation support</li>
        <li>Understanding and managing taxes</li>
        <li>Financial literacy and saving guidance</li>
    </ul>
</div>
<div className="col-md-6">
    <ul className="service-6-list">
        <li>Developing social communication skills</li>
        <li>Improving physical and daily living skills</li>
        <li>Personalised supervision of daily activities</li>
        <li>Support for independent living goals</li>
    </ul>
</div>
                                        </div>       
                                        {/* <div className="link-btn mb_30">
                                            <Link href="#" className="btn-1">Read More <span></span></Link>
                                        </div>              */}
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="p_relative text-lg-end">
                                            <div className="service-6-shape"><img src="assets/images/shape/pattern-1.png" alt="" /></div>
                                            <div className="p_relative">
                                                <img src="assets/images/resource/everyDay.jpg" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={activeIndex == 3 ? "tab-pane fadeInUp animated show active" : "tab-pane fadeInUp animated"}>
                            <div className="row clearfix">
                                <div className="col-lg-6">
                                    <h3 className="mb_30 fs_40"> Enjoy the unmatched perks of group </h3>
                                    <p className="mb_30 me-lg-5">Choose from a plethora of shared-living arrangements including SIL, STA, MTA and ILO. Own your independence and expect all aspects of individual care (hygiene requirements and other daily supports or respite care) regularly provided as you surround yourself with your community </p>
                                    <div className="row mb_30">
                                        {/* <div className="col-md-6">
                                            <ul className="service-6-list">
                                                <li>Retirement Advice</li>
                                                <li>Medical Alert Systems</li>
                                                <li>Light Housekeeping</li>
                                                <li>Campanion Care</li>
                                            </ul>
                                        </div> */}
                                        {/* <div className="col-md-6">
                                            <ul className="service-6-list">
                                                <li>Senior Care Resourse</li>
                                                <li>Condos for Seniors</li>
                                                <li>Light Housekeeping</li>
                                            </ul>
                                        </div> */}
                                    </div>       
                                    {/* <div className="link-btn mb_30">
                                        <Link href="#" className="btn-1">Read More <span></span></Link>
                                    </div>              */}
                                </div>
                                <div className="col-lg-6">
                                    <div className="p_relative text-lg-end">
                                        <div className="service-6-shape"><img src="assets/images/shape/pattern-1.png" alt="" /></div>
                                        <div className="p_relative">
                                            <img src="assets/images/resource/funfun.jpg" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </section>
  
        </>
    )
}

















            
